<template>
    <v-dialog v-model="dialog" @click:outside="$emit('close-dialog')" app persistent max-width="500" overlay-color="grey darken-1" overlay-opacity=".5">
        <v-snackbar v-model="snackbar" app centered top timeout="4000" style='z-index: 9;'>
            <div class="text-center">{{snackbarText}}</div>
        </v-snackbar>
        <v-card style="overflow: hidden;" class="rounded-xl">
            <v-row justify="center" align="center" class="mx-0">
                <v-btn icon style="position: absolute; left: 5px;">
                    <v-icon class="grey--text text--lighten-1" @click="$emit('close-dialog')">mdi-close</v-icon>
                </v-btn>
                <v-card-title style="word-break: normal;">Share Post</v-card-title>
            </v-row>
            <v-divider/>
            <div style="overflow-x: scroll;" class="d-flex flex-row justify-start justify-sm-space-around align-center hide-scroll-bar mx-0 my-2">
                <div class="d-flex flex-column align-center">
                    <v-btn @click="sharePost('email')" link depressed fab class="blue lighten-1 mx-2 mx-sm-0"><v-icon class="white--text">mdi-email</v-icon></v-btn>
                    <div class="text-caption mt-1">Mail</div>
                </div>
                <div class="d-flex flex-column align-center">
                    <v-btn @click="sharePost('gmail')" link depressed fab color="#EA4335" class="mx-2 mx-sm-0"><v-icon class="white--text">mdi-gmail</v-icon></v-btn>
                    <div class="text-caption mt-1">Gmail</div>
                </div>
                <div class="d-flex flex-column align-center">
                    <v-btn @click="sharePost('facebook')" link depressed fab color="#4267B2" class="mx-2 mx-sm-0"><v-icon class="white--text">mdi-facebook</v-icon></v-btn>
                    <div class="text-caption mt-1">Facebook</div>
                </div>
                <div class="d-flex flex-column align-center hidden-md-and-up">
                    <v-btn @click="sharePost('whatsapp')" link depressed fab color="#25D366" class="mx-2 mx-sm-0"><v-icon class="white--text">mdi-whatsapp</v-icon></v-btn>
                    <div class="text-caption mt-1">Whatsapp</div>
                </div>
                <div class="d-flex flex-column align-center">
                    <v-btn @click="sharePost('twitter')" link depressed fab color="#1DA1F2" class="mx-2 mx-sm-0"><v-icon class="white--text">mdi-twitter</v-icon></v-btn>
                    <div class="text-caption mt-1">Twitter</div>
                </div>
                <div class="d-flex flex-column align-center">
                    <v-btn @click="sharePost('linkedin')" link depressed fab color="#0e76a8" class="mx-2 mx-sm-0"><v-icon class="white--text">mdi-linkedin</v-icon></v-btn>
                    <div class="text-caption mt-1">Linkedin</div>
                </div>
            </div>
            <v-divider/>

            <!-- Share my settings toggle -->
            <v-row justify="start" align="center" no-gutters class="mx-4 mt-3 mb-1">
                <v-switch
                    v-model="shareMySettings"
                    dense
                    hide-details
                    color="primary"
                    class="mt-0 pt-0"
                >
                    <template v-slot:label>
                        <span class="text-caption">Share my current settings
                            <span class="grey--text">&nbsp;(playback, captions, volume)</span>
                        </span>
                    </template>
                </v-switch>
            </v-row>
            <v-row v-if="shareMySettings" justify="start" no-gutters class="mx-4 mb-2">
                <span class="text-caption grey--text font-italic">Receiver can change these anytime.</span>
            </v-row>

            <v-divider/>
            <v-row justify="space-around" align="center" class="mx-0 my-2">
                <v-text-field id="url-path" class="text-caption" style="max-width: 75%;" readonly color="transparent" :value="shareUrl" persistent-placeholder></v-text-field>
                <v-btn icon small depressed @click="copyFullRoute()">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
            </v-row>
            <v-divider/>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ShareDialog",
    props: ["dialog", "postData", "senderSettings"],
    components: {},
    data() {
        return {
            snackbar: false,
            snackbarText: "",
            shareMySettings: false,
        }
    },
    computed: {
        shareUrl() {
            // Rebuild from the route's query object so param order and the
            // leading "?" are always correct — no regex juggling.
            const query = { ...this.$route.query };
            ['share', 'ps', 'sc', 'cv', 'vv'].forEach(k => delete query[k]);

            if (this.shareMySettings && this.senderSettings) {
                query.share = '1';
                query.ps = this.senderSettings.ps;
                query.sc = this.senderSettings.sc;
                query.cv = this.senderSettings.cv;
                query.vv = this.senderSettings.vv;
            }

            const qs = new URLSearchParams(query).toString();
            return `https://tawq.in${this.$route.path}${qs ? '?' + qs : ''}`;
        },
    },
    methods: {
        async copyFullRoute() {
            try {
                await navigator.clipboard.writeText(this.shareUrl);
            } catch (err) {
                // Fallback for older browsers / non-secure contexts
                const copyText = document.getElementById("url-path");
                copyText.select();
                copyText.setSelectionRange(0, this.shareUrl.length);
                document.execCommand("copy");
            }
            this.snackbar = true;
            this.snackbarText = "Copied to clipboard.";
        },
        sharePost: async function(type) {
            const url = this.shareUrl;
            const message = `someone shared a tawq.in video with you — watch it with audio captions in multiple languages:%0D%0A%0D%0A${encodeURIComponent(url)}`;
            const subject = encodeURIComponent("a video was shared with you on tawq.in");
            switch(type) {
                case 'email':
                    document.location.href = `mailto:?subject=${subject}&body=${message}`;
                    break;
                case 'facebook': {
                    const facebookShare = `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}`;
                    window.open(facebookShare, "_blank");
                    break;
                }
                case 'whatsapp': {
                    const whatsappShare = `whatsapp://send?text=${encodeURIComponent(url)}`;
                    window.open(whatsappShare, "_blank");
                    break;
                }
                case 'twitter': {
                    const tweet = "someone shared a video with me on tawq.in — watch it with audio captions in multiple languages!"
                    const twitterShare = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}${'%0D%0A'}&text=${encodeURIComponent(tweet)}&hashtags=Tawqin,Tawq,CaptionYourVideo,VoiceOver,VoiceOverVideo,KeepTawqin`;
                    window.open(twitterShare, "_blank");
                    break;
                }
                case 'linkedin': {
                    const linkedinShare = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent("Tawqin")}&summary=${encodeURIComponent(this.postData.title)}&source=${encodeURIComponent("Tawqin")}`;
                    window.open(linkedinShare, "_blank");
                    break;
                }
                case 'gmail': {
                    const gmailSubject = encodeURIComponent("a video was shared with you on tawq.in");
                    const gmailShare = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${gmailSubject}&body=${message}&ui=2&tf=1&pli=1`;
                    window.open(gmailShare, "_blank");
                    break;
                }
            }
        },
    },
}
</script>

<style>
.hide-scroll-bar::-webkit-scrollbar { display: none; }
.hide-scroll-bar { -ms-overflow-style: none; scrollbar-width: none; }
</style>